import { render, staticRenderFns } from "./cggk.vue?vue&type=template&id=05870632&scoped=true&"
import script from "./cggk.vue?vue&type=script&lang=js&"
export * from "./cggk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05870632",
  null
  
)

export default component.exports